import { matchPath } from "react-router";

function checkIsLocationPathnameMatch(pathnameToCheck: string, comparePathname: string, exact?: boolean) {
    return !comparePathname || matchPath(pathnameToCheck, { path: comparePathname, exact }) !== null;
}

export default checkIsLocationPathnameMatch;
